module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_008_small.ad6cd92e.jpg";